<template>
  <custom-refinement-list attribute="venue">
    <template
      slot="item"
      slot-scope="{ item, refine }"
    >
      <label>
        <input
          type="checkbox"
          @click="refine(item.value)"
          :value="item.value"
          :checked="item.isRefined"
        />
        <span>{{ item.label }}</span>
      </label>
    </template>
  </custom-refinement-list>
</template>

<script>
import CustomRefinementList from './CustomRefinementList.vue';

export default {
  components: {
    CustomRefinementList,
  },
};
</script>
